import EditProcessLegal from "./EditProcess.vue"
export default EditProcessLegal